export const analyticsId = {
  OPEN_DEBIT_CARD_STEP_1_VIEW: 'OPEN_DEBIT_CARD_STEP_1_VIEW',
  OPEN_DEBIT_CARD_STEP_2_VIEW: 'OPEN_DEBIT_CARD_STEP_2_VIEW',
  OPEN_DEBIT_CARD_STEP_3_VIEW: 'OPEN_DEBIT_CARD_STEP_3_VIEW',
  OPEN_DEBIT_CARD_STEP_4_VIEW: 'OPEN_DEBIT_CARD_STEP_4_VIEW',
  OPEN_DEBIT_CARD_WIZARD_ERROR: 'OPEN_DEBIT_CARD_WIZARD_ERROR',
  OPEN_DEBIT_CARD_WIZARD_SUCCESS: 'OPEN_DEBIT_CARD_WIZARD_SUCCESS',
};

const commonFields = productName => ({
  sectionFamily: 'banking',
  sectionCategory: 'products',
  sectionName: 'cards',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'contractingCard',
  detalleProceso: productName,
  productName,
});

export const catalogue = {
  [analyticsId.OPEN_DEBIT_CARD_STEP_1_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_precontractual',
    pageName: '/contractingCard/step1/precontractual',
    processStep: 'step1',
    processDetail: 'precontractual',
  }),
  [analyticsId.OPEN_DEBIT_CARD_STEP_2_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_configuration',
    pageName: '/contractingCard/step2/configuration',
    processStep: 'step2',
    processDetail: 'configuration',
  }),
  [analyticsId.OPEN_DEBIT_CARD_STEP_3_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_shipment',
    pageName: '/contractingCard/step3/shipment',
    processStep: 'step3',
    processDetail: 'shipment',
  }),
  [analyticsId.OPEN_DEBIT_CARD_STEP_4_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_confirmation',
    pageName: '/contractingCard/step4/confirmation',
    processStep: 'step4',
    processDetail: 'confirmation',
  }),
  [analyticsId.OPEN_DEBIT_CARD_WIZARD_ERROR]: ({ errorMessage, productName }) => ({
    ...commonFields(productName),
    event_name: 'step_error',
    pageName: '/contractingCard/error',
    processStep: 'error',
    errorCategory: 'requestError',
    errorDescription: errorMessage,
  }),
  [analyticsId.OPEN_DEBIT_CARD_WIZARD_SUCCESS]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_success',
    pageName: '/contractingCard/success',
    processStep: 'success',
  }),
};
